import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
import ScrollToTop from "./components/ScrollToTop";
import { HelmetProvider } from "react-helmet-async";
import DownloadButton from "./components/DownloadButton"

// Lazy-load components
const Home = lazy(() => import('./pages/Home'));

function App() {
  return (
    <HelmetProvider>
    <Router>
      <ScrollToTop />
      <DownloadButton />
      {/* Suspense fallback to display while the component is loading */}
      <Suspense>
 
        <div>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </div>
      </Suspense>
    </Router>
    </HelmetProvider>
  );
}

export default App;
